export const SUPPORTS_OBJECT_CREATE = "create" in Object;
